const locale = window.siteConfig().locale || 'de-DE';

const currency = window.siteConfig().currency || 'EUR';
const options = {
    style: 'currency',
    currency: currency,
};

const currencySymbol = window.siteConfig().currencySymbol || '€';

export default class CurrencyFormatter {
    static priceFormatter = new Intl.NumberFormat(locale, options);
    static roundedPriceFormatter = new Intl.NumberFormat(locale, {
        ...options,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });

    static numberFormatter = new Intl.NumberFormat(locale);
    static roundedNumberFormatter = new Intl.NumberFormat(locale, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });

    static formattedPrice(price) {
        return this.priceFormatter.format(price / 100);
    }
    static formattedRoundedPrice(price) {
        return this.roundedPriceFormatter.format(price / 100);
    }
    static formatToParts(price, exclude = []) {
        if (this.priceFormatter.formatToParts) {
            return this.priceFormatter.formatToParts(price / 100).filter(part => !exclude.includes(part.type));
        }
        return [{ type: 'fallback', value: this.formattedPrice(price) }];
    }

    static formattedNumber(price) {
        return this.numberFormatter.format(price / 100);
    }
    static formattedRoundedNumber(price) {
        return this.roundedNumberFormatter.format(price / 100);
    }

    static formattedPriceWithSign(price) {
        return (price > 0 ? '+' : '') + this.priceFormatter.format(price / 100);
    }

    static symbol() {
        return currencySymbol;
    }

    static currency() {
        return currency;
    }
}
